import { LoginRedirectGate } from '../../features/auth/ui/LoginRedirectGate';

export function LoginPage() {
  return <LoginRedirectGate />;
}
